import { useState } from "react";
import { FilePlus2, X } from "lucide-react";

interface Props {
  onClose: () => void;
  onCreate: (data: { name: string; description: string }) => void;
}

export default function CreateKBModal({ onClose, onCreate }: Props) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!name.trim()) {
      setError("请输入知识库名称");
      return;
    }
    onCreate({ name: name.trim(), description: description.trim() });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4 backdrop-blur-sm" onClick={onClose}>
      <div className="w-full max-w-xl rounded-2xl border border-border bg-card p-6 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-xl font-semibold tracking-tight text-foreground">新建知识库</h2>
            <p className="mt-1 text-sm text-muted-foreground">创建一个新的知识库来组织和沉淀你的科研知识。</p>
          </div>
          <button onClick={onClose} className="rounded-lg p-2 text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground">
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="mt-6 space-y-4">
          <div>
            <label className="mb-2 block text-sm font-medium text-foreground">
              知识库名称 <span className="text-destructive">*</span>
            </label>
            <input
              autoFocus
              type="text"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setError("");
              }}
              placeholder="例如：量子计算研究文献库"
              className={`h-11 w-full rounded-lg border bg-background px-3 text-sm outline-none ring-offset-background placeholder:text-muted-foreground focus:ring-2 focus:ring-ring ${error ? "border-destructive" : "border-input"}`}
            />
            {error && <p className="mt-1 text-sm text-destructive">{error}</p>}
          </div>

          <div>
            <label className="mb-2 block text-sm font-medium text-foreground">描述（可选）</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="简单描述这个知识库的用途或内容..."
              rows={4}
              maxLength={200}
              className="w-full resize-none rounded-lg border border-input bg-background px-3 py-2.5 text-sm outline-none ring-offset-background placeholder:text-muted-foreground focus:ring-2 focus:ring-ring"
            />
            <div className="mt-1 text-right text-xs text-muted-foreground">{description.length}/200</div>
          </div>

          {/* single-type knowledge base: no type selection */}
        </div>

        <div className="mt-8 flex items-center justify-end gap-2">
          <button onClick={onClose} className="rounded-lg border border-border px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-accent">
            取消
          </button>
          <button onClick={handleSubmit} className="inline-flex items-center gap-2 rounded-lg bg-primary px-5 py-2 text-sm font-medium text-primary-foreground shadow-sm transition-colors hover:opacity-90">
            <FilePlus2 className="h-4 w-4" />
            创建知识库
          </button>
        </div>
      </div>
    </div>
  );
}
